import { useGetDefaultBankQuery } from "@/services/onboardingAPI";
import JavisLogo from "@/assets/images/pngs/iconJavis.png";

/**
 * Lấy thông tin ngân hàng mặc định để hiển thị brand (tên rút gọn + logo).
 * Dữ liệu được cache (keepUnusedDataFor lớn + không refetch mỗi mount) nên
 * gọi ở nhiều component cũng chỉ phát sinh 1 request.
 *
 * getDefaultBank có thể lỗi thật ở BE (GLOBAL_CONFIG SYSTEM_CONFIG/DEFAULT_BANK chưa
 * cấu hình, hoặc mã bank không có trong master domestic bank → COMMON_EXCEPTION, body.bank = null)
 * hoặc bị từ chối khi chưa có session. Khi đó fallback về logo Javis BIZ đóng gói sẵn trong bundle
 * để UI không trống — thay vì rơi về logo Javis/Sacombank cũ.
 */
export const useDefaultBank = () => {
  const { data, refetch } = useGetDefaultBankQuery(undefined, {
    refetchOnMountOrArgChange: false,
  });
  const bank = data?.body?.bank;
  const apiImage = (bank?.image as string) || "";
  return {
    shortName: (bank?.shortName as string) || "MBV",
    // Dùng chung cho mọi chỗ hiển thị brand (header pre-login, onboarding, favicon…).
    image: apiImage || JavisLogo,
    // API đã trả logo thật chưa — dùng để biết còn cần refetch hay không, vì `image`
    // luôn có giá trị (fallback) nên không thể lấy `!image` làm điều kiện.
    hasApiImage: !!apiImage,
    bankName: (bank?.bankName as string) || "",
    refetch,
  };
};

export default useDefaultBank;
